import { DEFAULT_LAYOUT } from '../base';
import { AppRouteRecordRaw } from '../types';

const CUSTOMER: AppRouteRecordRaw = {
  path: '/customer',
  name: 'customer',
  component: DEFAULT_LAYOUT,
  meta: {
    locale: 'menu.publicCustomer',
    requiresAuth: true,
    icon: 'icon-user-group',
    order: 5,
    roles: ['Admin', 'Supervisor'],
  },
  children: [
    {
      path: 'public-customer',
      name: 'PublicCustomer',
      component: () => import('@/views/customer/index.vue'),
      meta: {
        locale: 'menu.publicCustomer.unDistributed',
        requiresAuth: true,
        roles: ['Admin', 'Supervisor'],
      },
    },
    {
      path: 'distributed',
      name: 'Distributed',
      component: () => import('@/views/customer/distributed.vue'),
      meta: {
        locale: 'menu.publicCustomer.distributed',
        requiresAuth: true,
        roles: ['Admin', 'Supervisor'],
        hideInMenu: true,
      },
    },
  ],
};

export default CUSTOMER;
